module.exports = __webpack_public_path__ + "img/MaskGroup 2881.aa989c08.svg";